<div class="open-banking">
    <i class="btn-close icon-edponline-Bop-071" *ngIf="data.showClose" data-modal="dismiss()"
    (click)="dismissModal()" aria-hidden="true"></i>
    <div class="left-side">
        <span class="title">{{ 'pt.edp.edponline.open.banking.modal.title' | translate }}
            <span class="red">{{ 'pt.edp.edponline.open.banking.modal.title.bank' | translate }}</span>
        </span>
        <span class="description" [innerHTML]="'pt.edp.edponline.open.banking.modal.description' | translate"></span>
        <span class="d-none d-lg-block description-warning" [innerHTML]="'pt.edp.edponline.open.banking.modal.description.warning' | translate"></span>
    </div>
    <div class="right-side edp-scroll-disabled">
        <edp-loader *ngIf="loading" [size]="'full'" [position]="'center'" ></edp-loader>
        <ng-container *ngIf="!loading">
            <ng-container *ngFor="let bank of arrayBanks">
                <ng-container *ngIf="bankListSelected[0]?.bank_identifier === bank.bank_identifier">
                    <div class="selected-bank"><span class="text">{{ bank.institution_name }}</span></div>
                </ng-container>
                <ng-container *ngIf="!(bankListSelected[0]?.bank_identifier === bank.bank_identifier)">
                    <div class="bank-card cursor-pointer" (click)="bankClick(bank)" [ngClass]="{'border-red': bank.highlight}">
                        <span class="text">{{ bank.institution_name }}</span>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <span class="d-block d-lg-none description-warning" [innerHTML]="'pt.edp.edponline.open.banking.modal.description.warning' | translate"></span>
    </div>
</div>
